var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoogle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.04594 9.66844L3.489 11.7476L1.45341 11.7906C0.845063 10.6623 0.5 9.37131 0.5 7.99944C0.5 6.67284 0.822625 5.42184 1.3945 4.32031H1.39494L3.20719 4.65256L4.00106 6.45394C3.83491 6.93834 3.74434 7.45834 3.74434 7.99944C3.74441 8.58669 3.85078 9.14934 4.04594 9.66844Z",
    fill: "#FBBB00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3601 6.50513C16.452 6.98906 16.4999 7.48885 16.4999 7.99963C16.4999 8.57238 16.4397 9.13106 16.325 9.66997C15.9355 11.5038 14.9179 13.1051 13.5083 14.2383L13.5078 14.2379L11.2252 14.1214L10.9022 12.1047C11.8375 11.5561 12.5685 10.6977 12.9536 9.66997H8.67578V6.50513H13.016H16.3601Z",
    fill: "#518EF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5081 14.2377L13.5085 14.2381C12.1376 15.3401 10.396 15.9994 8.50021 15.9994C5.45361 15.9994 2.80483 14.2966 1.45361 11.7906L4.04614 9.66846C4.72174 11.4715 6.46108 12.7551 8.50021 12.7551C9.37668 12.7551 10.1978 12.5181 10.9024 12.1045L13.5081 14.2377Z",
    fill: "#28B446"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6064 1.84126L11.0147 3.96301C10.2855 3.5072 9.42353 3.24389 8.50003 3.24389C6.41475 3.24389 4.64287 4.58629 4.00112 6.45401L1.39497 4.32039H1.39453C2.72597 1.75336 5.40816 -0.000488281 8.50003 -0.000488281C10.4411 -0.000488281 12.2209 0.690949 13.6064 1.84126Z",
    fill: "#F14336"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.5 -0.000488281)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.1d4ac6eec3bb4341afed13822f514e9b.svg";
export { ForwardRef as ReactComponent };